import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { GlgTextInput, GlgSelect } from 'SharedComponents'
import { fetchPotentialLeaguesForCloningMergedParams } from '../../reducers/potential_leagues_for_cloning'
import {
  selectLeaguesCategories,
  selectLeaguesProductTypes,
  selectLeaguesSeasons,
  selectProductType,
  selectSeason,
  selectTour,
  selectCategory,
  setCategory,
  setSeason,
  setTour,
  setProductType,
  resetFilters,
  selectLeaguesTours,
  serializeFilters,
  mapToDropdown,
  mapCategoriesToDropdown,
  selectCurrentSeason,
  selectCurrentSeasonID,
  setTextSearch,
  selectTextSearch,
  withAllEntry,
  buildSeasonsDropdownItems,
} from '../../reducers/leagues_filter_values'
import {
  ALL_ENTRIES_FILTER_VALUE,
} from '../../constants'


const LeaguesBrowserFilters = () => {
  const dispatch = useDispatch()
  // All options
  const categories = withAllEntry(useSelector(selectLeaguesCategories))
  const productTypes = withAllEntry(useSelector(selectLeaguesProductTypes))
  const currentSeason = useSelector(selectCurrentSeason)
  const currentSeasonID = useSelector(selectCurrentSeasonID)
  const rawSeasons = useSelector(selectLeaguesSeasons)
  const allFirstItem = { value: ALL_ENTRIES_FILTER_VALUE, label: window.I18n.t('clone_leagues_sessions.dropdowns.all') }
  const seasons = buildSeasonsDropdownItems(rawSeasons, currentSeasonID, currentSeason, allFirstItem)
  const tours = withAllEntry(useSelector(selectLeaguesTours))

  // Selected option
  const category = useSelector(selectCategory)
  const productType = useSelector(selectProductType)
  const season = useSelector(selectSeason)
  const tour = useSelector(selectTour)
  const textSearch = useSelector(selectTextSearch)

  const handleTextSearchChange = (value) => {
    dispatch(setTextSearch(value))
  }

  return <div className='cls-lb-filters-container'>
    <span className='cls-lb-search-filters-list'>
      {/* Type filter */}
      <span className='cls-lb-search-filter-container'>
        <span className='cls-lb-search-filter-label'>
          {window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.type')}
        </span>
        <span className='cls-lb-filter-input'>
          <GlgSelect
            items={mapToDropdown(productTypes)}
            value={productType}
            selectorClassName={'dropdown-select'}
            onChange={(option) => { dispatch(setProductType(option)) }}
          />
        </span>
      </span>
      {/* Season filter */}
      <span className='cls-lb-search-filter-container'>
        <span className='cls-lb-search-filter-label'>
          {window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.season')}
        </span>
        <span className='cls-lb-filter-input'>
          <GlgSelect
            items={seasons}
            value={season}
            selectorClassName={'dropdown-select'}
            onChange={(option) => { dispatch(setSeason(option)) }}
          />
        </span>
      </span>
      {/* Category filter */}
      <span className='cls-lb-search-filter-container'>
        <span className='cls-lb-search-filter-label'>
          {window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.category')}
        </span>
        <span className='cls-lb-filter-input'>
          <GlgSelect
            items={mapCategoriesToDropdown(categories)}
            value={category}
            selectorClassName={'dropdown-select'}
            onChange={(option) => { dispatch(setCategory(option)) }}
          />
        </span>
      </span>
      {/* Tour filter - Optional, display only if available */}
      {Object.entries(tours).length > 1 &&
        <span className='cls-lb-search-filter-container'>
        <span className='cls-lb-search-filter-label'>
          {window.I18n.t('customer_center_menu.components.popups.general_create_league_popup.tour')}
        </span>
        <span className='cls-lb-filter-input'>
          <GlgSelect
            items={mapToDropdown(tours)}
            value={tour}
            selectorClassName={'dropdown-select'}
            onChange={(option) => { dispatch(setTour(option)) }}
          />
        </span>
      </span>
      }
      <button
        className={'cls-controls-text'}
        onClick={() => {
            dispatch(resetFilters())
            dispatch(fetchPotentialLeaguesForCloningMergedParams(
              serializeFilters(
                ALL_ENTRIES_FILTER_VALUE,
                ALL_ENTRIES_FILTER_VALUE,
                ALL_ENTRIES_FILTER_VALUE,
                ALL_ENTRIES_FILTER_VALUE,
              ),
            ))
          }
        }
      >{window.I18n.t('buttons.reset')}</button>
    </span>
    <div className="cls-lb-search-container">
      <GlgTextInput
        onChange={handleTextSearchChange}
        value={textSearch}
        withAddon
        debounceSpan={500}
      />
    </div>
  </div>
}

export default LeaguesBrowserFilters
